import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { X, Send } from "lucide-react";

const CAPTAIN = "/assistant-captain.png";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "pirate_assistant_sid";
const getSid = () => {
  let s = localStorage.getItem(SID_KEY);
  if (!s) { s = `v${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`; localStorage.setItem(SID_KEY, s); }
  return s;
};
const md = (t) => t.replace(/\*\*(.+?)\*\*/g, "<b>$1</b>").replace(/\n/g, "<br/>");

// 🤖 Ψηφιακός βοηθός επισκεπτών — μόνο σε δημόσιες σελίδες (όχι /admin).
export const VisitorAssistant = () => {
  const { pathname } = useLocation();
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [lift, setLift] = useState(false);
  const bottomRef = useRef(null);
  // Στα εργαλεία εξάσκησης (Οδηγός Αναπνοής κ.λπ.) το κουμπί κάλυπτε τα χειριστήρια
  const hidden = pathname.startsWith("/admin") || pathname.startsWith("/call") || pathname.startsWith("/mvp") || pathname.startsWith("/erotimatologio")
    || pathname.startsWith("/pacer") || pathname.startsWith("/ekpaideusi");

  useEffect(() => {
    // Μην καλύπτεις τη floating μπάρα του δωρεάν εργαστηρίου (κινητό): ανέβα πάνω της όταν φαίνεται.
    const check = () => setLift(!!document.querySelector('[data-testid="workshop-cta-sticky"], [data-sticky-bar]'));
    window.addEventListener("scroll", check, { passive: true });
    const t = setInterval(check, 800);
    return () => { window.removeEventListener("scroll", check); clearInterval(t); };
  }, []);
  useEffect(() => { fetch(`${API}/assistant/config`).then((r) => r.json()).then(setCfg).catch(() => setCfg({ enabled: false })); }, []);
  useEffect(() => {
    if (!open) return;
    fetch(`${API}/assistant/history/${getSid()}`).then((r) => r.json()).then((d) => setMsgs((m) => (m.length ? m : d.messages || []))).catch(() => {});
  }, [open]);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, busy]);
  useEffect(() => {
    if (!open || window.innerWidth >= 640) return undefined;
    const prev = document.body.style.overflow; document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (hidden || !cfg?.enabled || window.self !== window.top) return null;

  const send = async (e) => {
    e?.preventDefault();
    const text = input.trim();
    if (!text || busy) return;
    setInput("");
    setMsgs((m) => [...m, { role: "user", text }, { role: "assistant", text: "" }]);
    setBusy(true);
    try {
      const r = await fetch(`${API}/assistant/chat`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ session_id: getSid(), message: text, page: pathname }) });
      const reader = r.body.getReader(); const dec = new TextDecoder(); let buf = ""; let reply = "";
      for (;;) {
        const { value, done } = await reader.read(); if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n"); buf = parts.pop();
        for (const p of parts) {
          const line = p.replace(/^data: /, "").trim();
          if (!line || line === "[DONE]") continue;
          try { reply += JSON.parse(line).t || ""; } catch { /* ignore */ }
          setMsgs((m) => [...m.slice(0, -1), { role: "assistant", text: reply }]);
        }
      }
      if (!reply) setMsgs((m) => [...m.slice(0, -1), { role: "assistant", text: "Συγγνώμη, δεν μπόρεσα να απαντήσω. Δοκίμασε ξανά." }]);
    } catch {
      setMsgs((m) => [...m.slice(0, -1), { role: "assistant", text: "Πρόβλημα σύνδεσης. Δοκίμασε ξανά σε λίγο." }]);
    } finally { setBusy(false); }
  };

  return (
    <>
      {!open && (
        <button onClick={() => setOpen(true)} data-testid="assistant-open" aria-label="Βοηθός"
          className={`fixed right-4 z-[39] flex items-center gap-2 rounded-full bg-[#1E3A5F] text-white shadow-xl shadow-black/30 hover:bg-[#2b4f7d] transition-[bottom,background-color] duration-300 ${lift ? "bottom-[76px] p-1.5" : "bottom-5 pl-2 pr-5 py-2"}`}>
          <img src={CAPTAIN} alt="Κυβερνήτης" className="w-10 h-10 rounded-full bg-white/90 object-contain" />{!lift && <span className="text-sm font-bold">Ρώτα τον Κυβερνήτη</span>}
        </button>
      )}
      {open && (
        <div data-testid="assistant-panel" className="fixed bottom-3 right-3 left-3 sm:left-auto sm:right-4 sm:bottom-4 sm:w-[380px] max-w-[calc(100vw-1.5rem)] z-[70] h-[70dvh] sm:h-[560px] max-h-[85dvh] flex flex-col rounded-2xl overflow-hidden overscroll-contain shadow-2xl border border-white/10 bg-[#0B1A2E]">
          <div className="flex items-center gap-2 px-4 py-3 bg-[#1E3A5F] text-white">
            <img src={CAPTAIN} alt="" className="w-10 h-10 rounded-full bg-white/90 object-contain" />
            <div><p className="text-sm font-black leading-tight">Ο Κυβερνήτης · Η Πειρατεία του Νου</p><p className="text-[11px] text-white/60">Απαντά άμεσα · ο Κωνσταντίνος επικοινωνεί προσωπικά</p></div>
            <button onClick={() => setOpen(false)} className="ml-auto p-1.5 rounded-lg hover:bg-white/10" data-testid="assistant-close" aria-label="Κλείσιμο"><X className="w-5 h-5" /></button>
          </div>
          <div className="flex-1 overflow-y-auto overflow-x-hidden overscroll-contain px-3 py-3 space-y-2" data-testid="assistant-messages">
            <div className="max-w-[88%] rounded-2xl rounded-tl-sm bg-white/10 text-white/90 text-sm px-3.5 py-2.5">{cfg.greeting}</div>
            {msgs.map((m, i) => (
              m.role === "assistant" && !m.text && busy && i === msgs.length - 1 ? (
                <div key={i} className="flex items-center gap-2 max-w-[88%]" data-testid="assistant-typing">
                  <img src={CAPTAIN} alt="" className="w-7 h-7 rounded-full bg-white/90 object-contain animate-pulse" />
                  <div className="rounded-2xl rounded-tl-sm bg-white/10 text-white/70 text-sm px-3.5 py-2.5 flex items-center gap-2">
                    <span className="flex gap-1">
                      <span className="w-2 h-2 rounded-full bg-[#2DD4BF] animate-bounce" style={{ animationDelay: "0ms" }} />
                      <span className="w-2 h-2 rounded-full bg-[#2DD4BF] animate-bounce" style={{ animationDelay: "150ms" }} />
                      <span className="w-2 h-2 rounded-full bg-[#2DD4BF] animate-bounce" style={{ animationDelay: "300ms" }} />
                    </span>
                    Ο Κυβερνήτης σκέφτεται…
                  </div>
                </div>
              ) : (
                <div key={i} className={`max-w-[88%] break-words rounded-2xl text-sm px-3.5 py-2.5 ${m.role === "user" ? "ml-auto bg-[#2DD4BF] text-[#0B1A2E] rounded-tr-sm" : "bg-white/10 text-white/90 rounded-tl-sm"}`}
                  data-testid={`assistant-msg-${m.role}`} dangerouslySetInnerHTML={{ __html: md(m.text || "") }} />
              )
            ))}
            <div ref={bottomRef} />
          </div>
          <form onSubmit={send} className="flex items-center gap-2 p-2.5 border-t border-white/10 bg-[#0B1A2E] w-full">
            <input value={input} onChange={(e) => setInput(e.target.value)} placeholder={busy ? "Περίμενε την απάντηση…" : "Γράψε την ερώτησή σου…"} maxLength={2000} disabled={busy}
              className="flex-1 min-w-0 px-3.5 py-2.5 rounded-full bg-white/10 text-white placeholder-white/40 text-base outline-none focus:ring-2 focus:ring-[#2DD4BF]/60 disabled:opacity-60" style={{ fontSize: 16 }} data-testid="assistant-input" />
            <button type="submit" disabled={busy || !input.trim()} className="shrink-0 w-11 h-11 flex items-center justify-center rounded-full bg-[#2DD4BF] text-[#0B1A2E] disabled:opacity-40" data-testid="assistant-send" aria-label="Αποστολή">{busy ? <span className="w-4 h-4 border-2 border-[#0B1A2E]/40 border-t-[#0B1A2E] rounded-full animate-spin" /> : <Send className="w-4 h-4" />}</button>
          </form>
        </div>
      )}
    </>
  );
};
